import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import UpdateIcon from "@mui/icons-material/Update";
import { useState } from "react";
import { AgruparWithLabel } from "../../../Helpers/Agrupaciones/AgruparWithLabel";

import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";

//estilos para el boton de PDF
const styles = {
  pdfDownloadLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "25px",
    borderRadius: "5px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "#940404",
    cursor: "pointer",
    boxShadow: "3px 3px 3px #333",
    color: "rgba(255, 255, 255, 0.8)",
  },
};

export const TotalCarteraPorLinea = () => {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    sucursal: [],
    data: [],
    nombreSucursal: "",
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const Actualizar = () => {
    setLoader({ ...loader, mostrar: true });
    var idsucursal = Number(location.state.idsucursal);
    request
      .get(
        `TotalCarteraPorLinea/Listado?idsucursal=${Number(
          idsucursal === 13 ? 0 : idsucursal
        )}`
      )
      .then((result) => {
        const sucursalData = AgruparWithLabel(result, "idsucursal", "sucursal");
        const nombreSucursal =
          sucursalData.find((suc) => suc.id === idsucursal)?.label || "";

        setState({
          sucursal: sucursalData,
          data: result,
          nombreSucursal,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
      });
  };
  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    var idsucursal = Number(location.state.idsucursal);
    request
      .get(
        "TotalCarteraPorLinea/GenerarExcel?idsucursal=" +
          Number(idsucursal === 13 ? 0 : idsucursal) +
          "&titulo=" +
          state.data[0].sucursal
      )
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  //Link para descargar PDF
  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    var idsucursal = Number(location.state.idsucursal);
    request
      .get(
        `TotalCarteraPorLinea/ReporteLineaPDF?idsucursal=` +
          Number(idsucursal === 13 ? 0 : idsucursal) +
          "&titulo=" +
          state.data[0].sucursal
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const onHome = () => {
    history.push("/Creditoycobranza/ResumenCartera");
  };
  const onClickDetalle = (idsucursal, linea) => {
    if (linea === "TOTAL") return;
    history.push("/Creditoycobranza/TotalCarteraDetalle", {
      idsucursal,
      linea,
      sucursal: location.state.sucursal,
    });
  };
  useEffect(() => {
    Actualizar();
  }, []);

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  return (
    <div className="reporte-resumen-cartera-por-linea">
      <LoaderScreen loader={loader} />
      <header id="header">
        <div className="title">
          <div className="btn-resumen-por-linea-retroceder" onClick={() => onHome()}>
            <ArrowBackIcon /> Regresar
          </div>
          {state.data === undefined ||
          state.data === null ||
          state.data.length === 0
            ? "Sin Información para Mostrar"
            : state.data[0].sucursal}
        </div>
        <div className="buttons">
          <button onClick={() => Actualizar()} className="actualizar">
            <UpdateIcon /> Actualizar
          </button>
          <button className="excel" onClick={() => onGeneraExcel()}>
            <i className=" icon-file-excel" /> Excel
          </button>
          <button
            className="PDF"
            onClick={() => PDFDownloadButton()}
            style={{ backgroundColor: "#940404" }}
          >
            PDF
          </button>
        </div>
      </header>
      <div className="container-tabla-resumen-sucursal scroll">
        <table id="tabla-resumen-por-linea" cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th> Línea</th>
              <th>
                <div>Total Cartera</div>
              </th>
              <th>
                <div>Saldo a Favor</div>
              </th>
              <th>
                <div>Total</div>
              </th>
              <th>
                <div>Jurídico</div>
              </th>

              <th>%</th>
              <th>
                <div>Cartera Activa</div>
              </th>
              <th>%</th>
              <th>
                <div>Por Vencer</div>
              </th>
              <th>%</th>
              <th>
                <div>Vencida</div>
              </th>
              <th>%</th>
              <th>
                <div>De 1 a 15</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 15</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 30</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 60</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 90</div>
              </th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {state.sucursal.map((sucursal) => (
              <>
                {state.data
                  .filter((linea) => linea.idsucursal === sucursal.id)
                  .sort((a, b) => b.linea - a.linea)
                  .map((x) => (
                    <tr
                      className={
                        x.linea === "TOTAL" ? "row-total" : "row-detalle"
                      }
                      onClick={() =>
                        onClickDetalle(sucursal.id, x.linea, x.sucursal)
                      }
                    >
                      <td>{capitalizeWords(x.linea)}</td>
                      {/* <td>{FormatMoney(x.totalcartera + x.juridico)}</td> */}
                      <td>{FormatMoney(x.totalcartera)}</td>
                      <td>{FormatMoney(x.saldoafavor)}</td>
                      {/* <td>{FormatMoney(x.total + x.juridico)}</td> */}
                      <td>{FormatMoney(x.total)}</td>
                      <td>{FormatMoney(x.juridico)}</td>
                      <td>
                        {FormatMoney(
                          (x.juridico / (x.totalcartera )) * 100
                        )}
                      </td>
                      <td>{FormatMoney(x.activo)}</td>
                      <td>
                        {FormatMoney(
                          (x.activo / (x.totalcartera )) * 100
                        )}
                      </td>
                      <td>{FormatMoney(x.porvencer)}</td>
                      <td>
                        {FormatMoney(
                          (x.porvencer / (x.totalcartera )) * 100
                        )}
                      </td>
                      <td>{FormatMoney(x.vencido)}</td>
                      <td>
                        {FormatMoney(
                          (x.vencido / (x.totalcartera )) * 100
                        )}
                      </td>
                      <td>{FormatMoney(x.de1a15)}</td>
                      <td>{FormatMoney((x.de1a15 / x.vencido) * 100)}</td>
                      <td>{FormatMoney(x.mas15)}</td>
                      <td>{FormatMoney((x.mas15 / x.vencido) * 100)}</td>
                      <td>{FormatMoney(x.mas30)}</td>
                      <td>{FormatMoney((x.mas30 / x.vencido) * 100)}</td>
                      <td>{FormatMoney(x.mas60)}</td>
                      <td>{FormatMoney((x.mas60 / x.vencido) * 100)}</td>
                      <td>{FormatMoney(x.mas90)}</td>
                      <td>{FormatMoney((x.mas90 / x.vencido) * 100)}</td>
                    </tr>
                  ))}
                <tr className="row-espacio">
                  <td></td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// <tr className="row-sucursal">
// <td colSpan={2}>
//   {sucursal.id === 100 ? sucursal.label : sucursal.label}
//   {/* : sucursal.id + " - " + sucursal.label} */}
// </td>
// <td colSpan={15}></td>
// </tr>
